export enum CourseSimilarPathEnum {
  default = 'course-api/v2/catalog/courses/',
}
